export default {
  credit_card: require('./credit_card.png'),
  credit_cardless: require('./credit_cardless.png'),
  ewallet: require('./ewallet.png'),
  retail_outlet: require('./retail_outlet.png'),
  virtual_account: require('./virtual_account.png')
}
